import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import Vuesax from 'vuesax'

import 'vuesax/dist/vuesax.css' //Vuesax styles
Vue.use(Vuesax, {
  // options here
}) 




Vue.config.productionTip = false

import en from './locale/en';
import es from './locale/es';
import fr from './locale/fr';
import it from './locale/it';
import tr from './locale/tr';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en', // set locale
  messages:  {en, es, fr, it, tr}, // set locale messages
})


router.beforeEach((to, from, next) => { 
  let language = to.params.locale;
  if (!language) {
      language = 'en';
  } 
  i18n.locale = language;
  next();
});

new Vue({
  router,
  store,
  i18n,
  render: function (h) { return h(App) }
}).$mount('#app')

 